import { AxiosResponse } from 'axios';
import { useEffect, useRef, useState } from 'react';
import { replaceInStateArray } from 'tools/tools';
export interface FormConfirmResponse {
    status: 'CONFIRM';
    messages: {
        [key: string]: {
            error: string;
            props?: any;
        };
    };
}

export interface FormConfirmState {
    key: string;
    message: string;
    props?: any;
    confirmed: boolean;
}

export const ConfirmField = '__confirm__';

export default function useActOnConfirm() {
    const [formConfirmState, setFormConfirmState] = useState<Array<FormConfirmState>>([]);

    const handleConfirm = (key: string): void => {
        const index = formConfirmState.findIndex((i) => i.key == key);
        replaceInStateArray(setFormConfirmState, index, {
            ...formConfirmState[index],
            confirmed: true,
        });
    };

    const handleCancel = (): void => {
        setFormConfirmState([]);
    };

    useEffect(() => {
        if (!promiseResolve.current) {
            return;
        }
        if (formConfirmState.length == 0) {
            promiseResolve.current([]);
            promiseResolve.current = undefined;
            return;
        }
        if (formConfirmState.filter((c) => !c.confirmed).length == 0) {
            promiseResolve.current(formConfirmState.map((s) => s.key));
            promiseResolve.current = undefined;
            setFormConfirmState([]);
        }
    }, [formConfirmState]);

    const promiseResolve = useRef<(value: Array<string>) => void>();
    const actOnConfirm = (response: AxiosResponse<FormConfirmResponse>, data: any): Promise<any> => {
        const promise = new Promise<Array<string>>((resolve, reject) => {
            promiseResolve.current = resolve;
        });
        const newState: Array<FormConfirmState> = [];
        for (const [key, value] of Object.entries(response.data.messages)) {
            newState.push({
                key,
                message: value.error,
                props: value.props,
                confirmed: false,
            });
        }
        setFormConfirmState(newState);
        return promise;
    };

    return { actOnConfirm, formConfirmState, handleConfirm, handleCancel };
}
